import React from 'react';
import { Button, InputNumber } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

interface IQuantitySelectorProps {
    onQuantitySubmit: (quantity: number) => void;
    loading: boolean;
    min?: number;
    quantity: number;
    label?: string;
    labelPosition?: 'top' | 'side'; // control label placement
    labelClassName?: string;
}

export const QuantitySelector: React.FC<IQuantitySelectorProps> = ({
    onQuantitySubmit,
    loading,
    min = 1,
    quantity,
    label = 'Quantity:',
    labelPosition = 'side',
    labelClassName,
}) => {
    return (
        <div
            className={`quantity-selector flex ${
                labelPosition === 'top' ? 'flex-col items-start space-y-1' : 'items-center space-x-2'
            }`}
        >
            {/*<label className={`${labelClassName ? labelClassName : 'text-xs text-slate-600 whitespace-nowrap'}`}>*/}
            {/*    <strong>{label}</strong>*/}
            {/*</label>*/}
            <div className="flex items-center space-x-2">
                <Button
                    size="small"
                    className="minus-btn"
                    icon={<MinusOutlined />}
                    onClick={() => {
                        const newQuantity = Number(quantity) - 1;
                        onQuantitySubmit(newQuantity);
                    }}
                    disabled={loading || quantity === min}
                />

                <InputNumber
                    min={min}
                    step={1}
                    controls={false}
                    size="small"
                    style={{ width: 60 }}
                    value={quantity}
                    onPressEnter={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        const target = e.target as HTMLInputElement;
                        if (Number(target?.value)) {
                            onQuantitySubmit(Number(target.value));
                        }
                    }}
                    onBlur={e => {
                        e.stopPropagation();
                        const value = Number(e.target.value);
                        if (value) {
                            onQuantitySubmit(value);
                        }
                    }}
                    disabled={loading}
                    enterKeyHint="done"
                />

                <Button
                    size="small"
                    className="plus-btn"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        const newQuantity = Number(quantity) + 1;
                        onQuantitySubmit(newQuantity);
                    }}
                    disabled={loading}
                />
            </div>
        </div>
    );
};
